import { useState } from 'react';
import { Box, Button, Text, useMultiStyleConfig } from '@chakra-ui/react';
import { getDeleteAccountLink } from 'app/store/Auth/selectors';
import { useAppSelector } from 'app/store';
import { useIsMobile } from 'app/utils/hooks';
import { PasswordChangeDialog } from '../PasswordChangeDialog';
import { EmailChangeDialog } from '../EmailChangeDialog';
import { DeleteAccountDialog } from '../DeleteAccountDialog';
import { useAccountSettingsRows } from './hooks';

const MIN_BUTTON_WIDTH = '88px';

export const AccountSettings = () => {
  const deleteAccountLink = useAppSelector(getDeleteAccountLink);
  const [passwordChangeOpen, setPasswordChangeOpen] = useState(false);
  const [emailChangeOpen, setEmailChangeOpen] = useState(false);
  const [deleteAccountOpen, setDeleteAccountOpen] = useState(false);

  const isMobileView = useIsMobile(false);
  const styles = useMultiStyleConfig('SettingsPageList', {
    isMobile: isMobileView,
    minButtonWidth: MIN_BUTTON_WIDTH,
  });

  const rows = useAccountSettingsRows({
    setDeleteAccountOpen,
    setPasswordChangeOpen,
    setEmailChangeOpen,
  });

  return (
    <>
      {rows.map(
        ({ primaryText, secondaryText, secondTextTestId, button, sx }) => (
          <Box sx={sx} key={primaryText}>
            <Box sx={styles.container}>
              <Box
                sx={styles.textWrapper}
                {...(!secondaryText && {
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                })}
              >
                <Text
                  sx={styles.primaryText}
                  pt={secondaryText ? 2 : undefined}
                  title={primaryText}
                >
                  {primaryText}
                </Text>
                {secondaryText && (
                  <Text
                    sx={styles.secondaryText}
                    {...(secondTextTestId
                      ? { 'data-testid': secondTextTestId }
                      : {})}
                    title={secondaryText}
                  >
                    {secondaryText}
                  </Text>
                )}
              </Box>
              {button && (
                <Button
                  size="sm"
                  variant="secondary"
                  p={0}
                  minWidth={MIN_BUTTON_WIDTH}
                  onClick={button.action}
                >
                  {button.label}
                </Button>
              )}
            </Box>
          </Box>
        )
      )}
      {deleteAccountLink && (
        <DeleteAccountDialog
          open={deleteAccountOpen}
          link={deleteAccountLink}
          onClose={() => {
            setDeleteAccountOpen(false);
          }}
        />
      )}
      <PasswordChangeDialog
        open={passwordChangeOpen}
        onClose={() => {
          setPasswordChangeOpen(false);
        }}
      />
      <EmailChangeDialog
        open={emailChangeOpen}
        onClose={() => {
          setEmailChangeOpen(false);
        }}
      />
    </>
  );
};
